import { forwardRef, useId, type TextareaHTMLAttributes } from "react";
import { cn } from "@/shared/lib/cn";

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, label, error, id, ...props }, ref) => {
    const autoId = useId();
    const textareaId = id || autoId;

    return (
      <div className="space-y-1.5">
        {label && (
          <label htmlFor={textareaId} className="block text-sm font-medium text-sand-700 dark:text-sand-300">
            {label}
          </label>
        )}
        <textarea
          ref={ref}
          id={textareaId}
          className={cn(
            "w-full min-h-[100px] px-3 py-2.5 rounded-xl resize-y",
            "bg-white border border-sand-300 text-sand-900",
            "placeholder:text-sand-400 text-sm leading-relaxed",
            "transition-colors duration-200",
            "hover:border-ocean-300",
            "focus:outline-none focus:border-ocean-500 focus:ring-2 focus:ring-ocean-500/20",
            "dark:bg-sand-800 dark:border-sand-700 dark:text-sand-100 dark:placeholder:text-sand-500",
            error && "border-coral-500 focus:border-coral-500 focus:ring-coral-500/20",
            className,
          )}
          {...props}
        />
        {error && <p className="text-xs text-coral-500 pl-0.5">{error}</p>}
      </div>
    );
  },
);

Textarea.displayName = "Textarea";
